import { AnimatedLayout, HomeTemplate, LayoutTemplate } from '@/components';
import { useRouter } from 'next/router';
const Home = () => {
  const router = useRouter();
  return (
    <AnimatedLayout slideFrom="left">
      <HomeTemplate />
    </AnimatedLayout>
  );
};
Home.getLayout = function PageLayout(page: React.ReactNode) {
  return <LayoutTemplate>{page}</LayoutTemplate>;
};
export default Home;
